/**
 * @module router/orders-crm
 * @description UC-REG-162 — Ruta del CRM de órdenes.
 *   - /orders-crm → bandeja del operador comercial (staff, no paciente)
 */
const ordersCrmRoutes = [
  {
    path: "/orders-crm",
    name: "orders-crm",
    component: () =>
      import(
        /* webpackChunkName: "orders-crm" */ "../components/orders-crm/OrdersCRM.vue"
      ),
  },
];

export default ordersCrmRoutes;
